export const menuSeparatorDefaultClasses = [
  'h-[2px]',
  'rounded-lg',
  'bg-neutral-weak',
];
